import { hasScope } from '@nyce/admin-kit/api';
import { SCOPES } from '../../api';
import { BASE_URL, useHubLogin } from '../../session';
import { createAuthClient, type AuthClient } from '../../identity/api';
import { proxyFetch, targetSession } from '../../identity/session';

/**
 * M23 transport: NYCE Design's tenant registry through the hub proxy `/design-admin/<target>/<path>` (Design's
 * `/api/admin/v1/<path>`). The environment's AUTH session travels as `X-Target-Token` (one refresh on a 401); Design
 * accepts it when the operator tenant holds `design:tenants:read|write` there. Only the routes in the hub's allow-list
 * (`Design/DesignEndpoints.cs`) get through: list, get, usage, create, update.
 */
const clients = new Map<string, AuthClient>();

export function designClient(target: string): AuthClient {
  let c = clients.get(target);
  if (!c) {
    c = createAuthClient({
      baseUrl: `${BASE_URL}/design-admin/${encodeURIComponent(target)}`,
      auth: targetSession(target),
      fetch: proxyFetch,
    });
    clients.set(target, c);
  }
  return c;
}

/** Whether the hub lets this operator change Design tenants (`ophub:design:write`); Design still checks its own scope. */
export function useDesignWrite(): boolean {
  return hasScope(useHubLogin()?.scopes, SCOPES.designWrite);
}

/** Test hook. */
export const resetDesignClients = () => clients.clear();
